import { getProductWithCategory } from '@pro/product/utils';
import { IProduct } from '@pro/product/interface';

export const product: IProduct = {
    ...getProductWithCategory('mc2'),
    topBanner: {
        type: 'swiperBanner',
        config: {
            width: 1720,
            height: 1200,
            carouselFlag: 1,
            hasSideSpace: 1,
        },
        list: [
            {
                src: 'asset/width-1720/picture/53cb21e15cf075e848ad61a92fc204df.png',
                alt: ''
            },
            {
                src: 'asset/width-1720/picture/5552f41b9d0432aa7fc7a73ba52f3e5b.png',
                alt: ''
            },
            {
                src: 'asset/width-1720/picture/4f09c1791c967d5afd601b7750100a2f.png',
                alt: ''
            },
            {
                src: 'asset/width-1720/picture/44f441a5f066e8d467d74fb4197316a0.png',
                alt: ''
            },
            {
                src: 'asset/width-1720/picture/27d5f6462b51962dc5d228eaf0b111e5.png',
                alt: ''
            },
        ]
    },
    intro: 'Precision controller to automate your lighting fixtures and monitor your grow environment.',
    features: [
        [
            {
                icon: 'file-asset/file/af6d2f3b3dfecc49ef7f88f0e467a935.svg',
                title: 'Advanced Spectrum Control',
                description: 'Individually control Far Red, UV, and Full Spectrum channels with independent on/off timing and dimming settings, allowing precise light recipes for each growth stage.'
            },
            {
                icon: 'file-asset/file/fbea20df9e734c05e250ab2066e6efcb.svg',
                title: 'Grouped Fixture Control',
                description: 'Supports separate group control within the same daisy-chain, allowing different lighting strategies in one room without additional controllers.'
            },
        ],
        [
            {
                icon: 'file-asset/file/a4b5b6e2200947759e1542e22ce6169a.svg',
                title: 'Two Independent Lighting Channels',
                description: 'Each channel can independently control up to 100 Matrix LED fixtures, enabling flexible room layouts and scalable system design.'
            },
            {
                icon: 'file-asset/file/5ba5a96cc71c09ac9b2081eff6f079a5.svg',
                title: 'Custom Presets & Lighting Schedules',
                description: 'Create, save, and run custom lighting presets with programmable schedules to ensure consistent, repeatable results across cycles.'
            },
            {
                icon: 'file-asset/file/ff129565de59326f0ba48a34e6edf37e.svg',
                title: 'RJ12 Plug-and-Play Connectivity',
                description: 'Simple RJ12 daisy-chain connection allows fast installation and reliable communication between fixtures and the controller.'
            }
        ]
    ],
    specifications: {
        picture: {
            src: 'asset/width-1500/picture/b3fae49e130b73e72bf8d3848ebea3f2.png',
            width: 1500,
            height: 1440,
            alt: 'specifications picture fr',
        },
        list: [
            { name: 'Adapter Input', value: '100-240V, 50/60Hz 0.2A' },
            { name: 'Controller Input', value: '12V, 1A' },
            { name: 'Lighting Control Channels', value: '2' },
            { name: 'Lighting Control Level', value: 'OFF/25%/40%/50%/60%/80%/100%' },
            { name: 'Number of Fixtures Per Channel', value: '80(0-10V); 100(RS-485)' },
            { name: 'Temperature Range', value: '-20-80°C(-4-176°F)' },
            { name: 'Humidity Range', value: '0-100%' }
        ],
        pdf: 'file-asset/file/5b1f0bfecd98ab8dee7c5f4cdc0c245a.pdf',
    }
};